import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MaterialIcon from '@/components/ui/MaterialIcon';
import AppShell from '@/components/layout/AppShell';
import toast from 'react-hot-toast';

const OfflineCardPage: React.FC = () => {
  const navigate = useNavigate();
  const [offlineData, setOfflineData] = useState<any>(null);

  useEffect(() => {
    // Try to load cached card data from localStorage
    const cachedCard = localStorage.getItem('leeris_offline_card');
    if (cachedCard) {
      setOfflineData(JSON.parse(cachedCard));
    } else {
      toast.error('Aucune carte enregistrée hors ligne');
      // In a real app we might redirect or show a different state
    }
  }, []);

  if (!offlineData) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-background-light dark:bg-background-dark p-4">
        <MaterialIcon icon="wifi_off" className="text-4xl text-gray-400" />
        <p className="text-gray-500 text-center">Aucune carte disponible hors ligne.<br/>Connectez-vous une fois pour la télécharger.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="rounded-xl bg-primary px-4 py-2 font-bold text-[#102216]"
        >
          Retour au tableau de bord
        </button>
      </div>
    );
  }

  return (
    <AppShell title="Mode Hors Ligne" showBack backLabel="Accueil" onBack={() => navigate('/dashboard')}>
      <div className="flex flex-col gap-6 p-4 md:p-0 md:pt-4 md:max-w-xl">
        <div className="bg-orange-100 dark:bg-orange-900/20 text-orange-800 dark:text-orange-200 p-3 rounded-xl text-sm flex items-center gap-2">
           <MaterialIcon icon="wifi_off" />
           <span>Vous consultez une version hors ligne de votre carte.</span>
        </div>

        {/* Card Visualization (Simplified for offline) */}
         <div className="relative w-full rounded-2xl overflow-hidden shadow-lg bg-gradient-to-br from-gray-800 to-black text-white p-6 aspect-[1.58/1]">
             <div className="relative z-10 flex flex-col h-full justify-between">
                 <div className="flex justify-between items-start">
                     <img src="/logo-leeris.png" alt="Leeris" className="h-7 w-auto rounded-md bg-white px-2 py-1" />
                     <div className="bg-white/20 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium">Offline</div>
                 </div>

                 <div className="flex flex-col gap-1">
                     <p className="text-xs opacity-80 uppercase tracking-wider">Adhérent</p>
                     <p className="font-bold text-lg truncate">{offlineData.userName}</p>
                     <p className="text-sm opacity-90">{offlineData.memberNumber}</p>
                 </div>

                 <div className="flex justify-between items-end">
                     <div>
                         <p className="text-[10px] opacity-80 uppercase">Expire le</p>
                         <p className="text-sm font-medium">{offlineData.expiresAt}</p>
                     </div>
                 </div>
             </div>
        </div>

        {/* QR Code Section */}
        <div className="flex flex-col items-center gap-4 bg-white dark:bg-surface-dark p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-white/5">
            <h2 className="font-bold text-[#111813] dark:text-white">QR Code</h2>
            <div className="bg-white p-2 rounded-xl border border-gray-100">
                {offlineData.qrCodeData ? (
                    <img src={offlineData.qrCodeData} alt="QR Code" className="w-48 h-48 object-contain" />
                ) : (
                    <div className="w-48 h-48 flex items-center justify-center bg-gray-100">QR indisponible</div>
                )}
            </div>
        </div>
      </div>
    </AppShell>
  );
};

export default OfflineCardPage;
